var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-mono whitespace-pre bg-gray-900 text-gray-100 overflow-auto p-4"},[_vm._v("\n  "+_vm._s(_vm.contents)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }